<template>
  <div class="flex flex-col items-center justify-center py-24 text-center max-w-[882px] mx-auto px-4">
    <h2 class="pb-8 text-4.5xl">
      Well Well Well is the world's go-to marketplace to experience what's hot in wellness.
    </h2>
    <NuxtLink to="/experiences" class="underline">
      View All Events
    </NuxtLink>
  </div>
</template>